export default __webpack_public_path__ + "static/media/21t.636b25e5.jpg";